module.exports = __webpack_public_path__ + "static/media/ATOM.eb1c41d4.png";